// extracted by mini-css-extract-plugin
module.exports = {"logo":"snA7b1LN"};